import { Link } from "react-router-dom";
import { Button } from 'semantic-ui-react';

const Home = () => {
    return (
        <section className="h-100 bg-dark">
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col">
                        <div className="card card-registration my-4">
                            <div className="row g-0">
                                <div className="col-xl-6 d-none d-xl-block">
                                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                        alt="" className="img-fluid"
                                    />
                                </div>
                                <div className="col-xl-6 d-flex justify-content-center align-items-center">

                                    <div className="d-flex justify-content-center pt-3">
                                        <Link to="/register" className="nav-link">
                                            <Button type="button" className="btn btn-light btn-lg">Register</Button>
                                        </Link>
                                        <Link to="/login" className="nav-link">
                                            <Button type="button" className="btn btn-light btn-lg">Login</Button>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Home;